import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../../config';
import { useTranslation } from '../../translations';
import { Banner } from '../ui/Banner';
import { formatDateTime } from '../../utils/format';
import { wyslanoZapasowo } from '../../utils/bladSerweraPoczty';

// Ostatni błąd serwera poczty firmy przy wysyłce (uwagi ze strony, 26.10.2026; serwer zapisuje go
// w email_settings.last_error_code, migracja 065, Login/backend/lib/transportFirmy.js). Wadliwy SMTP
// wychodził dopiero przy wysyłce, a firma nie wiedziała, że jej klienci nie dostają maili.

// Przyczyna według rodzaju z serwera. Klucze wypisane wprost, bo audyt tłumaczeń widzi tylko
// stałe klucze.
export function przyczynaBleduSerwera(rodzaj, t) {
  switch (rodzaj) {
    case 'auth': return t('emailSettings.sendErrorCause.auth');
    case 'dns': return t('emailSettings.sendErrorCause.dns');
    case 'connect': return t('emailSettings.sendErrorCause.connect');
    case 'tls': return t('emailSettings.sendErrorCause.tls');
    case 'sender': return t('emailSettings.sendErrorCause.sender');
    case 'timeout': return t('emailSettings.sendErrorCause.timeout');
    case 'connection_lost': return t('emailSettings.sendErrorCause.connectionLost');
    case 'rejected': return t('emailSettings.sendErrorCause.rejected');
    default: return t('emailSettings.sendErrorCause.other');
  }
}

/** `{ rodzaj, czas }` z ustawień albo null, gdy nie ma czego pokazać. */
export function bladZUstawien(settings) {
  return settings && settings.last_error_code
    ? { rodzaj: settings.last_error_code, czas: settings.last_error_at }
    : null;
}

/** Treść komunikatu: kiedy, dlaczego, czy mail wyszedł z adresu the.rENT i co zrobić. */
export function OpisBleduSerwera({ blad }) {
  const { t, currentLanguage } = useTranslation();
  return (
    <>
      {t('emailSettings.sendErrorWhen', { czas: formatDateTime(blad.czas, { locale: currentLanguage }), przyczyna: przyczynaBleduSerwera(blad.rodzaj, t) })}{' '}
      {wyslanoZapasowo(blad.rodzaj) ? t('emailSettings.sendErrorFallback') : t('emailSettings.sendErrorNoFallback')}{' '}
      {t('emailSettings.sendErrorFix')}
    </>
  );
}

/**
 * Strona główna administratora: własne zapytanie (GET /api/email-settings jest tylko dla
 * administratora), best-effort. Odpowiedź inna niż 200 i błąd sieci dają ciszę. Firma spoza
 * Premium (plan FIRMY, bez wyjątku super-admina) nie wysyła przez własny serwer
 * (lib/transportFirmy.js), więc wtedy też cisza.
 */
export function BladSerweraPocztyStronaGlowna() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [blad, setBlad] = useState(null);
  useEffect(() => {
    const administrator = localStorage.getItem('isAdmin') === '1' || localStorage.getItem('isSuperAdmin') === '1';
    if (!administrator) return undefined;
    let aktualne = true;
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/api/email-settings`, { credentials: 'include' });
        if (!r.ok) return;
        const d = await r.json();
        if (!aktualne || d.organizationPlan !== 'premium' || (d.settings && d.settings.is_active === false)) return;
        setBlad(bladZUstawien(d.settings));
      } catch (_) { /* cisza: baner jest dodatkiem */ }
    })();
    return () => { aktualne = false; };
  }, []);
  if (!blad) return null;
  return (
    <Banner
      tone="danger"
      title={t('emailSettings.sendErrorTitle')}
      data-cy="home-email-send-error"
      style={{ marginBottom: 'var(--sp-4)' }}
      action={{ label: t('emailSettings.sendErrorOpen'), onClick: () => navigate('/email-settings'), dataCy: 'home-email-send-error-open' }}
    >
      <OpisBleduSerwera blad={blad} />
    </Banner>
  );
}
